import React, { useEffect, useState } from 'react'
import { Button, Card, Container, Table } from 'react-bootstrap'
import { useNavigate, useParams } from 'react-router-dom'
import Cookies from 'js-cookie'
import axios from 'axios'
import toast from 'react-hot-toast'
import { theme } from '../theme/theme'
import { BASE_URL } from '../constants'

const AssociatePayment = () => {
  const { broker_id } = useParams()

  console.log('Passing  Broker Id: ', broker_id)
  const [paymentData, setPaymentData] = useState(null)
  const [brokerName, setBrokerName] = useState('')
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState('')
  const navigate = useNavigate()
  // Fetch transactions when broker_id changes
  useEffect(() => {
    if (broker_id) {
      fetchAssociatePayment(broker_id)
    }
  }, [broker_id])

  const fetchAssociatePayment = async (broker_id) => {
    const token = Cookies.get('authToken')
    setLoading(true)
    setError('')
    try {
      const response = await axios.get(BASE_URL+
        `/get/broker/payment?broker_id=${broker_id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )

      const paymentRes = response.data.data
      console.log('Response of all brokers payment history: ', paymentRes)

      if (response.status === 200 && Array.isArray(paymentRes)) {
        setPaymentData(paymentRes)
      } else {
        console.error('API did not return an array:', response.data)
        setPaymentData([]) // Handle the case where "data" is not an array
      }
      // Fetch broker's name
      const brokerResponse = await axios.get(BASE_URL+
        `/brokers/search`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            'Content-Type': 'application/json',
          },
        },
      )
      console.log("Broker's name:", brokerResponse.data.data)
      const brokers = brokerResponse.data.data
      const broker = brokers.find((b) => b.broker_id === parseInt(broker_id)) // Find broker by ID
      setBrokerName(broker ? broker.name : 'Unknown')
    } catch (error) {
      console.error('Error fetching payment details:', error)
      setError('Failed to fetch payment details. Please try again.')
    } finally {
      setLoading(false)
    }
  }

  const handleAssociateTransactionPrint = (payment) => {
    if (payment?.id) {
      console.log('Selected transaction id after print button:', payment.id)
      navigate(`/transactionprint/${broker_id}`, {
        state: { payment },
      })
    } else {
      console.log('No valid payment selected.')
      toast.error('No valid transaction selected for printing.')
    }
  }

  const backHandler = () => {
    window.location.href = '/allassociate'
  }

  return (
<Container className="pb-3" style={{fontFamily: theme.font.family }}>
      {brokerName ? (
<div className='px-3 mb-3' style={{ backgroundColor: theme.colors.background }}>
                  <div className='d-flex justify-content-start p-2 mb-2' style={{cursor: 'pointer',alignItems:'center' }} 
              onClick={backHandler}
                  >
          <i class="fa-solid fa-arrow-left" style={{color:theme.colors.primary}}></i>
          <span className='ms-2'> 
              Back to Associate List
            
            </span>
        </div>
          
         <p className="mb-4 fw-bold" style={{ color: theme.colors.primary, borderBottom: `2px solid ${theme.colors.secondary} `, paddingBottom: '8px' , fontSize: '1.5rem'}}>
                   Transaction History of {brokerName.toUpperCase()} with ID:{' '}
              {broker_id}        
          </p>
<div className=' mb-3' style={{ backgroundColor: theme.colors.background }}>

          {/* <Card.Body> */}
            <Table
              bordered
              hover
              responsive="md"
              className="text-center table table-bordered table-hover"
            >
              <thead className="text-start position-sticky top-0">
                {console.log('All Payment Data: ', paymentData)}
<tr>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Paid Amount</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Method Type</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Date</th>
  <th style={{ backgroundColor: `${theme.colors.primary}`, color: theme.colors.background }}>Action</th>
</tr>

              </thead>
              <tbody className="text-start">
                {loading ? (
                  <tr>
                    <td colSpan={7} className="text-center">
                      Loading transaction history...
                    </td>
                  </tr>
                ) : !Array.isArray(paymentData) || paymentData.length === 0 ? (
                  <tr>
                    <td colSpan={7} className="text-center text-danger">
                      No transaction history available
                    </td>
                  </tr>
                ) : (
                  paymentData.map((payment) => {
                    console.log('TRANSACTION', payment) // Add this line to debug

                    return (
                      <tr key={payment.id}>
                        <td>₹ {payment.paid_amount}</td>
                        <td>{payment.method_type}</td>
                        <td>
                          {new Date(payment.date).toLocaleDateString('en-GB', {
                            year: 'numeric',
                            month: 'long',
                            day: 'numeric',
                          })}
                        </td>
                        <td>
                          <Button
                            className="text-white fw-bold btn bttn-outline-primary"
                            onClick={() =>
                              handleAssociateTransactionPrint(payment)
                            }
                          >
                            Print
                          </Button>
                        </td>
                      </tr>
                    )
                  })
                )}
              </tbody>
            </Table>
</div>
        </div>
      ) : (
        <div className="text-center text-danger">
          {error || 'No payment data available.'}
        </div>
      )}
    </Container>
  )
}

export default AssociatePayment
